import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { INotificationDetails } from '../models/notification.model';
import { AuthUserService } from '../shared/auth/auth-user.service';
import { Roles } from '../constants/roles';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  private readonly baseURL = `${environment.apiUrl}/Notification/`;
  loggedInUserRole: string | undefined;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly authUserService: AuthUserService) {

    type RoleKey = keyof typeof Roles;

    this.authUserService.loggedInUserProfile.subscribe(userRole => {
      this.loggedInUserRole = (Object.keys(Roles) as RoleKey[])
        .find(k => Roles[k] === userRole);
      //console.log('UserRole: ', this.loggedInUserRole)
    })
  }

  // Get Alert Notification Details
  getAlertNotificationsDetailsAsync$(): Observable<INotificationDetails> {
    return this.httpClient.get<INotificationDetails>(this.baseURL);
  }

  // MarkAsReadNotification
  updateNotificationAsReadAsync$(userAlertNotificationId: number): Observable<boolean> {
    const url = this.baseURL + `${userAlertNotificationId}`;
    return this.httpClient.put<boolean>(url, userAlertNotificationId);
    //return this.httpClient.patch<boolean>(url, userAlertNotificationId);
  }
}
